export const Types = {
    GET_TEST_CRITERIAS: 'GET_TEST_CRITERIAS',
    GET_TEST_CRITERIASSUCCESS: 'GET_TEST_CRITERIASSUCCESS',
    SET_TEST: 'SET_TEST',
    SET_INITIAL_INPUT_ENABLED: 'SET_INITIAL_INPUT_ENABLED',
    SET_INPUT_TEXT: 'SET_INPUT_TEXT',
    HANDLE_COMMENT_CHANGE: 'HANDLE_COMMENT_CHANGE',
    RESET_MODEL: 'RESET_MODEL',
    SET_MENU: 'SET_MENU'
}

export const getTestCriterias = () => ({
    type: Types.GET_TEST_CRITERIAS
});


export const getTasksSuccess = (testCriterias) => (
    {
        type: Types.GET_TEST_CRITERIASSUCCESS,
        payload: { testCriterias }
    });

export const setTest = (test) => ({
    type: Types.SET_TEST,
    payload: test
});


export const setInitialInputEnabled = (initialInputEnabled) => ({
    type: Types.SET_INITIAL_INPUT_ENABLED,
    payload: initialInputEnabled
});

export const handleInputChange = (FieldText, Value, Value1) => ({
    type: Types.SET_INPUT_TEXT,
    payload: { FieldText, Value, Value1 }
});


export const handleCommentChange = (comment) => ({
    type: Types.HANDLE_COMMENT_CHANGE,
    payload: { comment }
});


export const resetModel = () => ({
    type: Types.RESET_MODEL
})

export const setMenu = (items) => ({
    type: Types.SET_MENU,
    payload: items
})